/**
 * Modulo function that behaves in a mathematically correct way e.g. operates on
 * negative numbers.
 *
 * @param {number} dividend - the number we take a modulo from
 * @param {number} divisor - the number specifying modulo group
 *
 * @returns {number}
 * Natural number inside [0, divisor).
 *
 * @example
 * if (mod(-2, 7) === 5) {
 *    doSomething()
 * }
 */
export default function mod(dividend, divisor) {
  return dividend - divisor * Math.floor(dividend / divisor);
}